import { hasTranslation, t } from "./i18n";

/** `notif_*` translation keys some backends send instead of the bare event code. */
const aliases: Record<string, string> = {
  notif_topup_accept: "topup_accept",
  notif_withdraw_created: "withdraw_created",
  notif_withdraw_accept: "withdraw_accept",
  notif_withdraw_declined: "withdraw_decline",
  notif_verification_accept: "verification_accept",
  notif_verification_decline: "verification_decline",
  notif_aml_request: "aml_request",
  notif_aml_accept: "aml_accept",
  notif_balance_change: "balance_change",
  notif_account_restricted: "account_limited",
  notif_time_restricted: "time_limited",
  notif_procedure_passed: "procedure_completed",
  toast_email_confirmed: "email_confirmed",
  email_confirmation: "email_confirmed"
};

const reportedUnknownCodes = new Set<string>();

export function formatNotificationText(value: string) {
  const code = value.trim().toLowerCase();
  const event = aliases[code] ?? code;
  const key = `dashboard.event_${event}`;
  // Known backend events have their own translation (`dashboard.event_<code>`).
  if (hasTranslation(key)) return t(key);
  if (value.includes(" ")) return value;
  if (!reportedUnknownCodes.has(code)) {
    reportedUnknownCodes.add(code);
    console.info(`[notifications] unknown event code: ${JSON.stringify(value)}`);
  }
  const segment = value.split(".").at(-1) ?? value;
  return segment.replaceAll("_", " ").replace(/^./, (letter) => letter.toUpperCase());
}

export function getBalanceDelta(before: number | null | undefined, after: number | null | undefined) {
  if (typeof before !== "number" || typeof after !== "number") return null;
  const delta = after - before;
  return delta === 0 ? null : delta;
}
